module.exports = __webpack_public_path__ + "img/bo.23be87ca.svg";